import { createSlice } from "@reduxjs/toolkit";
import { AddNewJobInitialValues } from "./model/job";

const addNewJobInitialValues: AddNewJobInitialValues = {
  title: null,
  description: null,
  title_id: null,
  min_jd_year: null,
  max_jd_year: null,
  office_id: [],
  practice_area_id: [],
  specialty_id: [],
  skills: [],
  industry_id: [],
  language_id: [],
  admission_id: [],
  relocation: false
};

const jobSlice = createSlice({
  name: "v2Job",
  initialState: {
    addNewJobInitialValues
  },
  reducers: {
    resetAddNewJobValues: (state) => {
      state.addNewJobInitialValues = addNewJobInitialValues;
    },
    setAddNewJobValue: (state, action) => {
      const { field, value } = action.payload;
      (state.addNewJobInitialValues as any)[field] = value;
    }
  }
});

export const { resetAddNewJobValues, setAddNewJobValue } = jobSlice.actions;
export default jobSlice.reducer;
